/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class ManageScheduledResourcesModel {

        private systemLevel: Wars.Domain.Model.SystemLevel;
        private existingSystemCodes: Array<Wars.Domain.Model.Codes.CodeGroup>;
        private existingScheduledResources: Array<Wars.Domain.Model.ScheduledResourceConfiguration>;
        private selectedCodeGroup: Wars.Domain.Model.Codes.CodeGroup;
        private newScheduledResource: Wars.Domain.Model.ScheduledResourceConfiguration;
        private newScheduledResourceName = "";
     
        constructor(
            public id: string,
            private manageScheduledResourcesService: services.ManageScheduledResourcesService,
            private manageSystemCodesService: services.ManageSystemCodesService,
            private systemLevelService: services.SystemLevelService,
            private deleteService: services.DeleteService,
            private modalService: any) {
            this.modalService = modalService;
            this.existingSystemCodes = [];
            this.existingScheduledResources = [];
            this.selectedCodeGroup = undefined;
            this.loadAllSystemCodes();
            this.loadAllScheduledResources();
        }
        
        addNewScheduledResource(): void {
            this.newScheduledResource = this.manageScheduledResourcesService.createNewScheduledResourceConfiguration(this.selectedCodeGroup);
            this.newScheduledResource.name = this.newScheduledResourceName;

            if (this.id) {
                this.newScheduledResource.processConfiguration_id = this.id;
            } else {
                this.newScheduledResource.systemLevel_id = !this.id && this.systemLevel ? this.systemLevel.id : undefined;
                this.newScheduledResource.mySystemLevel = !this.id ? this.systemLevel : undefined;
            }

            this.saveNewScheduledResource();
        }

        canSaveNewScheduledResource(): boolean {
            if (this.selectedCodeGroup == undefined) return false;
            if (this.newScheduledResourceName.trim() === "") return false;
            return true;
        }
        
        deleteScheduledResource(scheduledResource: Wars.Domain.Model.ScheduledResourceConfiguration) {
            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "ScheduledResourceConfiguration",
                scheduledResource.id,
                "Scheduled Resource Successfully Deleted",
                () => {
                    this.existingScheduledResources.remove(scheduledResource);
                },
                "Scheduled ResourceCould not be Deleted");
        }
        
        saveNewScheduledResource(): void {
            this.manageScheduledResourcesService.saveAllChanges(() => {
                 this.saveSucceeded();
            });
        }

        editExistingScheduledResource(scheduledResource: Wars.Domain.Model.ScheduledResourceConfiguration) {
            this.showModal(scheduledResource);
        }

        private loadAllSystemCodes(): void {
            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.systemLevel = systemLevel;
                    this.existingSystemCodes = systemLevel.myCodeGroups;
                    if (this.id) {
                        this.manageSystemCodesService.getAllCodesForProcessConfiguration(this.id).then(
                            (codeGroups) => {
                                this.existingSystemCodes = this.existingSystemCodes.concat(codeGroups);
                            });
                    }
                });
        }

        private loadAllScheduledResources(): void {
            this.manageScheduledResourcesService.getAllScheduledResourcesForProcessConfiguration(this.id).then(
                (scheduledResources) => {
                    this.existingScheduledResources = scheduledResources;
                });
        }

        private saveSucceeded(): void {
            this.existingScheduledResources.push(this.newScheduledResource);
            this.newScheduledResource = undefined;
            this.newScheduledResourceName = "";
        }
        
        private showModal(scheduledResource: Wars.Domain.Model.ScheduledResourceConfiguration) { // Just provide a template URL, a controller and call 'showModal'.
            this.modalService.showModal({
                templateUrl: "./app/views/modals/_scheduledResourceEditModal.html",
                controller: "editScheduledResourceModalController",
                inputs: {
                    scheduledResource: scheduledResource
                }
            }).then(modal => {
                // The modal object has the element built, if this is a bootstrap modal
                // you can call 'modal' to show it, if it's a custom modal just show or hide
                // it as you need to.                
                modal.element.modal();
                modal.close.then(result => {
                    if (result) {
                        this.manageScheduledResourcesService.saveAllChanges();
                    } else {
                        this.manageScheduledResourcesService.rejectChanges();
                    }
                });
            });
        }
    }
}